import { takeEvery } from 'redux-saga/effects';
import { GET_CONFIG_FETCH, UPDATE_BANK_CONFIG_SETTINGS } from '../constants';
// eslint-disable-next-line import/no-cycle
import { getConfigSaga, updateBankConfigSettingsSaga } from './configSaga';

export function* rootConfigSaga() {
  yield takeEvery(GET_CONFIG_FETCH, getConfigSaga);
  yield takeEvery(UPDATE_BANK_CONFIG_SETTINGS, updateBankConfigSettingsSaga);
}
